import { AutocompleteOption } from '../components/formField/AutocompleteField'

export type SubmitType = {
  label: string
  value: string
  group: string
}

export const typeOut: SubmitType = {
  label: 'Đi ra ngoài trong giờ làm việc',
  value: 'out',
  group: 'CHẤM CÔNG (TIME SHEET)'
}
export const typeWFH: SubmitType = {
  label: 'Làm việc tại nhà (WFH)',
  value: 'wfh',
  group: 'CHẤM CÔNG (TIME SHEET)'
}

export const typeForGet: SubmitType = {
  label: 'Làm việc tại văn phòng (Office)',
  value: 'forget',
  group: 'CHẤM CÔNG (TIME SHEET)'
}

export const typeOT: SubmitType = {
  label: 'Overtime trong tuần (OT trong tuần)',
  value: 'ot',
  group: 'CHẤM CÔNG (TIME SHEET)'
}

export const typeOTWeekend: SubmitType = {
  label: 'Overtime cuối tuần (OT cuối tuần)',
  value: 'ot_in_weekend',
  group: 'CHẤM CÔNG (TIME SHEET)'
}

export const typeOTHoliday: SubmitType = {
  label: 'Overtime ngày lễ (OT ngày lễ)',
  value: 'ot_in_holiday',
  group: 'CHẤM CÔNG (TIME SHEET)'
}

export const typeOffPay: SubmitType = {
  label: 'Nghỉ có lương (12 ngày phép)',
  value: 'off_salary',
  group: 'NGHỈ PHÉP'
}

export const typeOffUnPay: SubmitType = {
  label: 'Nghỉ không lương',
  value: 'off_not_salary',
  group: 'NGHỈ PHÉP'
}

export const typeSummer: SubmitType = {
  label: 'Nghỉ hè (5 ngày/năm)',
  value: 'off_summer',
  group: 'NGHỈ PHÉP'
}

export const typeInsurance: SubmitType = {
  label: 'Nghỉ ốm BHXH',
  value: 'off_insurance',
  group: 'NGHỈ PHÉP'
}

export const typeMyWedding: SubmitType = {
  label: 'Nghỉ kết hôn: bản thân kết hôn (3 ngày)',
  value: 'off_my_wedding',
  group: 'NGHỈ PHÉP'
}

export const typeChildWedding: SubmitType = {
  label: 'Nghỉ kết hôn: con kết hôn (1 ngày)',
  value: 'off_child_wedding',
  group: 'NGHỈ PHÉP'
}

export const typeFuneral: SubmitType = {
  label: 'Nghỉ tang gia : bố mẹ mình hoặc bố mẹ chồng/vợ, con của mình mất (3 ngày)',
  value: 'off_funeral',
  group: 'NGHỈ PHÉP'
}

export const typeWomen: SubmitType = {
  label: 'Nghỉ chế độ dành riêng cho nữ (tối đa 5 ngày liên tục/tháng, 30 phút/ngày)',
  value: 'off_women',
  group: 'NGHỈ PHÉP'
}

export const typeMaternity: SubmitType = {
  label: 'Nghỉ thai sản (số ngày xác nhận với team Corp)',
  value: 'off_maternity',
  group: 'NGHỈ PHÉP'
}

const type = [
  typeWFH,
  typeForGet,
  typeOut,
  typeOT,
  typeOTWeekend,
  typeOTHoliday,
  typeOffPay,
  typeOffUnPay,
  typeWomen,
  typeSummer,
  typeInsurance,
  typeMyWedding,
  typeMaternity,
  typeChildWedding,
  typeFuneral
]
export default type

export const TYPE_DATE = [
  { label: 'Nghỉ cả ngày', value: 'all_day' },
  { label: 'Nghỉ nửa ngày', value: 'hafl_day' }
]

export const TYPE_SUBMIT: AutocompleteOption[] = [
  { label: typeWFH.label, value: typeWFH.value, group: typeWFH.group },
  { label: typeForGet.label, value: typeForGet.value, group: typeForGet.group },
  { label: typeOut.label, value: typeOut.value, group: typeOut.group },
  { label: typeOT.label, value: typeOT.value, group: typeOT.group },
  { label: typeOTWeekend.label, value: typeOTWeekend.value, group: typeOTWeekend.group },
  { label: typeOTHoliday.label, value: typeOTHoliday.value, group: typeOTHoliday.group },
  { label: typeOffPay.label, value: typeOffPay.value, group: typeOffPay.group },
  { label: typeOffUnPay.label, value: typeOffUnPay.value, group: typeOffUnPay.group },
  { label: typeWomen.label, value: typeWomen.value, group: typeWomen.group },
  { label: typeSummer.label, value: typeSummer.value, group: typeSummer.group },
  { label: typeInsurance.label, value: typeInsurance.value, group: typeInsurance.group },
  { label: typeMyWedding.label, value: typeMyWedding.value, group: typeMyWedding.group },
  { label: typeMaternity.label, value: typeMaternity.value, group: typeMaternity.group },
  { label: typeChildWedding.label, value: typeChildWedding.value, group: typeChildWedding.group },
  { label: typeFuneral.label, value: typeFuneral.value, group: typeFuneral.group }
]
